export default "__VITE_ASSET__cdd3435d__"